import request from '@/utils/request'

export function updateAnnouncementCfg(data) {
  return request({
    url: 'api/v1/announcement/update',
    method: 'post',
    data: data
  })
}

export function getAnnouncementList(data) {
  return request({
    url: 'api/v1/announcement/getList',
    method: 'post',
    data: data
  })
}

